<style>
 .text-red {
    color: #b61c2c !important;
    cursor: pointer;
 }
</style>
<template>

  <Toast ref="toast" />
    
    <!-- Main Header start -->
    <div class="appointment_header">
        <div class="container py-2">
            <div class="d-flex justify-content-between align-items-center">
            
                <!-- Logo -->
                <div class="appointment_logo">
                    <img src="@/assets/Images/Logo/kims-logo.png" alt="KIMS HEALTH">
                </div>

                <!-- Toggle Icon (mobile only) -->
                <div class="menu-icon d-md-none" @click="toggleMobileMenu">
                    <i class="fas fa-bars"></i>
                </div>

                <!-- Desktop Menu -->
                <div class="applicant_links d-none d-md-flex align-items-center">
                    <a :href="LangingHomePage">Home</a>
                    <span class="separator">|</span>
                    <a href="https://www.kimshealth.org/trivandrum/visa_medicals/">FAQ</a>
                    <span class="separator">|</span>
                    <a :href="trackAppointment">Track Appointment(s)</a>
                    
                    <!-- Right side: User -->
                    <div v-if="agentStore.agentDetails" ref="userBadge" class="d-flex align-items-center position-relative gap-2">
                      <span class="separator">|</span>
                        <!-- Icon -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#b71c1c" viewBox="0 0 16 16">
                            <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                        </svg>

                        <!-- User Info -->
                        <div class="user-badge d-flex flex-column" @click.stop="toggleDropdown" style="cursor: pointer;">
                            <span style="color: #b61c2c; font-weight: 600;">{{ agentName }}</span>
                            <!-- <span style="color: #b61c2c; font-size: 12px;">{{ agentEmail }}</span> -->
                        </div>

                        <!-- Dropdown -->
                        <transition name="fade">
                            <div v-if="dropdownOpen" class="user-dropdown">
                            <button class="dropdown-item" @click="goToProfile"><i class="fa-solid fa-user me-2"></i>Profile</button>
                            <button class="dropdown-item logout" @click="logout"><i class="fa-solid fa-right-from-bracket me-2"></i>Logout</button>
                            </div>
                        </transition>
                    </div>

                </div>
            </div>

            <!-- Mobile Menu (hidden by default) -->
            <div class="mobile-links d-md-none flex-column mt-2" :class="{ 'd-flex': mobileMenuOpen, 'd-none': !mobileMenuOpen }">
                <a :href="LangingHomePage">Home</a>
                <a href="https://www.kimshealth.org/trivandrum/visa_medicals/">FAQ</a>
                <a :href="trackAppointment">Track Appointment(s)</a>

                <!-- Profile (only if logged in) -->
                <a v-if="agentStore.agentDetails" @click="goToProfile" class="mobile-link">
                    <i class="fa-solid fa-user me-2"></i> {{ agentName }}
                </a>

                <!-- Logout -->
                <a v-if="agentStore.agentDetails" @click="logout" class="mobile-link logout-link mt-2">
                    <i class="fa-solid fa-right-from-bracket me-2"></i> Logout
                </a>

                <!-- <br>
                <div v-if="agentStore.agentDetails" class="user-badge d-flex flex-column gap-1">
                    <span style="color: #b61c2c; font-weight: 600;">{{ agentName }}</span>
                    <span style="color: #b61c2c; font-size: 12px;">{{ agentEmail }}</span>
                    <button @click="logout" class="btn btn-sm btn-outline-danger mt-1">Logout</button>
                </div> -->
            </div>


        </div>
    </div>

   
       <!-- Hospital Profile Modal -->
      <div class="modal fade" id="profileModal" tabindex="-1" aria-hidden="true">
        <div :class="modalDialogClass">
          <div class="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
            
            <!-- Header -->
            <div class="modal-header py-3 px-4 text-white"
                style="background: linear-gradient(135deg, #d32f2f, #b71c1c);">
              <div class="d-flex align-items-center">
                <img src="@/assets/Images/Logo/Footer Logo.png" alt="Hospital Logo"
                    style="height: 35px; margin-right: 12px;">
                <!-- <h5 class="modal-title fw-bold mb-0">Agent Profile</h5> -->
              </div>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <!-- Body -->
            <div class="modal-body p-4" v-if="agentStore.agentDetails" style="word-break: break-word; overflow-wrap: anywhere;">
              <div class="row">
                <!-- Personal Details -->
                <div class="col-md-6 mb-3">
                  <div class="p-3 border rounded-3 bg-light h-100">
                    <h6 class="fw-bold text-danger mb-3">Personal Information</h6>
                    <p class="mb-2"><strong>Name:</strong> {{ agentStore.agentDetails.user.name }}</p>
                    <p class="mb-2"><strong>Email:</strong> {{ agentStore.agentDetails.user.email }}</p>
                    <p class="mb-0"><strong>Contact:</strong> {{ agentStore.agentDetails.user.contact_no }}</p>
                  </div>
                </div>

                <!-- Agency Details -->
                <div class="col-md-6 mb-3">
                  <div class="p-3 border rounded-3 bg-light h-100">
                    <h6 class="fw-bold text-danger mb-3">Agency Details</h6>
                    <p class="mb-2"><strong>Agency Name:</strong> {{ agentStore.agentDetails.user.agent.agency_name }}</p>
                    <!-- <p class="mb-2"><strong>Aadhaar:</strong> {{ agentStore.agentDetails.user.agent.aadhaar }}</p> -->
                    <p class="mb-0">
                      <strong>Status:</strong>&emsp13;&emsp14;
                      <span :class="agentStore.agentDetails.user.agent.is_verified ? 'text-success fw-semibold' : 'text-warning fw-semibold'">
                        {{ agentStore.agentDetails.user.agent.is_verified ? 'Verified' : 'Not Verified' }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <!-- Divider -->
              <hr class="my-3">

              <!-- Hospital Footer Info (Optional) -->
              <div class="text-center small text-muted">
                <p class="mb-0">KIMS Health — Secure Agent Access Portal</p>
              </div>
            </div>

            <!-- Footer -->
            <div class="modal-footer d-flex justify-content-between align-items-center py-3"
                style="background: linear-gradient(135deg, #d32f2f, #b71c1c);">
                <!-- Change Password Button -->
                <span class="text-white fw-semibold"
                      style="cursor: pointer; text-decoration: underline;"
                      @click="openChangePasswordModal">
                  Are you sure? Reset your login password
                </span>

              <button type="button" class="btn btn-light px-4" data-bs-dismiss="modal">Close</button>
            </div>

          </div>
        </div>
      </div>


      <!-- First Modal: Email Confirmation -->
      <div class="modal fade" id="emailAgentModal" tabindex="-1" aria-labelledby="emailAgentModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content py-3">

            <!-- Close button -->
            <button type="button" class="btn-close position-absolute top-0 end-0 m-3" data-bs-dismiss="modal" aria-label="Close"></button>
            
            <div class="modal-header px-5 border-0 justify-content-center">
              <h5 class="modal-title">
                <img src="@/assets/Images/Logo/kims-logo.png" width="250">
              </h5>
            </div>

            <div class="modal-body px-lg-5 text-center">
              <p class="mb-4 text-start">Please confirm your Email address</p>

              <div class="mb-3 text-start">
                <input type="email"
                      v-model="reemail"
                      class="form-control mb-3 custom-placeholder"
                      readonly>
              </div>

              <a class="btn btn-danger w-100" :disabled="loading" @click="validationMain">
                <span v-if="loading"><i class="fa fa-spinner fa-spin"></i> Processing...</span>
                <span v-else>Confirm</span>
              </a>
            </div>

          </div>
        </div>
      </div>


      <!-- otp verification -->
      <div class="modal fade" id="otpModal" tabindex="-1" aria-labelledby="otpModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content p-4 rounded-4">

                  <!-- Close button -->
                  <button type="button" class="btn-close position-absolute top-0 end-0 m-3" data-bs-dismiss="modal" aria-label="Close"></button>

                  <div class="modal-header px-5 border-0 justify-content-center">
                    <h5 class="modal-title"><img src="@/assets/Images/Logo/kims-logo.png" width="250"></h5>
                  </div>



                  <div class="modal-body">
                      <!-- <img src="@/assets/Images/Logo/kims-logo.png" alt="KIMSHEALTH" class="mb-3" style="max-width:260px;"> -->
                      <p class="otp_text mb-4">Please enter the OTP received on your email address</p>
          
                      <div class="d-flex justify-content-center mb-3 gap-1 otp-input-group flex-wrap justify-content-between">
                      <input
                          v-for="(digit, index) in otp"
                          :key="index"
                          type="text"
                          class="form-control otp-box text-center"
                          maxlength="1"
                          v-model="otp[index]"
                          @input="focusNext(index, $event)"
                          @keydown.backspace="focusPrev(index, $event)"
                          ref="otpInputs"
                      />
                      </div>
          
                      <small v-if="errors.otpError" class="text-danger">{{ errors.otpError }}</small>
          
                      <a class="btn btn-danger w-100" @click="validationOTPMain(registeredEmail)" :disabled="loading || otpIncomplete">
                        <span v-if="!loading && !resendloading">Confirm</span>
                        <span v-else-if="resendloading">
                          <i class="fa fa-spinner fa-spin"></i> Resending...
                        </span>
                        <span v-else>
                          <i class="fa fa-spinner fa-spin"></i> Processing...
                        </span>
                      </a>
          
                      <div class="d-flex justify-content-between mt-3">
                          <span class="resend">Resend OTP in <span class="timer">{{ formattedTime }}</span></span>
                          <a href="#" 
                            class="resend_btn text-decoration-none" 
                            @click.prevent="handleResend(registeredEmail)" 
                            :class="{'text-muted': timer > 0 || resendloading, 'text-danger': timer === 0 && !resendloading}" 
                            :style="(timer > 0 || resendloading) ? 'pointer-events: none;' : 'pointer-events: auto;'">
                            <span v-if="!resendloading">Resend</span>
                            <span v-else>
                                <i class="fa fa-spinner fa-spin"></i> Resending...
                            </span>
                          </a>

                      </div>
                  </div>

            </div>
          </div>
      </div>


      <!-- Change Password Modal -->
      <div class="modal fade" id="changePasswordModal" tabindex="-1" aria-labelledby="changePasswordModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content py-3">

            <!-- Close button -->
            <button type="button" class="btn-close position-absolute top-0 end-0 m-3" data-bs-dismiss="modal" aria-label="Close"></button>

            <div class="modal-header px-5 border-0 justify-content-center">
              <h5 class="modal-title"><img src="@/assets/Images/Logo/kims-logo.png" width="250"></h5>
            </div>

            <div class="modal-body px-lg-5 text-center">
              <p class="mb-4 text-start">Please enter your new password</p>

              <div class="mb-3 text-start">
                <input type="password"
                      v-model="newPassword"
                      class="form-control mb-3 custom-placeholder"
                      placeholder="New Password">
              </div>

              <div class="mb-3 text-start">
                <input type="password"
                      v-model="confirmPassword"
                      class="form-control mb-3 custom-placeholder"
                      placeholder="Confirm Password">
                      <small v-if="errors.passwordError && !confirmPasswordError" class="text-danger">
                        {{ errors.passwordError }}
                      </small>
              </div>

              <a class="btn btn-danger w-100" :disabled="loadingChangePassword" @click="updatePassword(registeredEmail)">
                <span v-if="loadingChangePassword"><i class="fa fa-spinner fa-spin"></i> Processing...</span>
                <span v-else>Update Password</span>
              </a>

            </div>

          </div>
        </div>
      </div>

      
        
</template>
<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useAgentStore } from '@/store/agent';
import { useRouter } from 'vue-router';
import { AgentLogout, AgentOTPResend, AgentVerifyOTP, AgentUpdatePassword } from '@/api/Agent/sign';
import Toast from '@/components/Toast/agentToast.vue';

// State
const LangingHomePage = '/';
const trackAppointment = '/trackAppointment';
const dropdownOpen = ref(false);

// Agent store & router
const agentStore = useAgentStore();
const router = useRouter();

// Refs
const userBadge = ref(null);
const toast = ref(null); // <-- Toast ref
const mobileMenuOpen = ref(false);
const modalDialogClass = ref('modal-dialog modal-dialog-centered modal-lg');

// Load agent details
onMounted(() => {
  agentStore.loadAgentDetails();
  updateModalClass();
  window.addEventListener('resize', updateModalClass);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateModalClass);
});

// Computed
const agentName = computed(() => agentStore.agentDetails?.user?.name || '');
const agentEmail = computed(() => agentStore.agentDetails?.user?.email || '');
const formattedTime = computed(() => {
  const minutes = Math.floor(timer.value / 60);
  const seconds = timer.value % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
});
const otpIncomplete = computed(() => otp.value.some(d => !d));

const updateModalClass = () => {
  if (window.innerWidth <= 768) {
    // Mobile
    modalDialogClass.value = 'modal-dialog modal-dialog-centered modal-lg';
  } else {
    // Desktop
    modalDialogClass.value = 'modal-dialog modal-dialog-centered modal-lg';
  }
};

const loading = ref(false);
const resendloading = ref(false);
const errors = ref({ reemail: '', otpError: '', passwordError: '' });
const reemail = ref('');
const otp = ref(Array(5).fill('')); // adjust length if needed
const registeredEmail = ref(''); // store confirmed email for OTP modal
const timer = ref(180); // total seconds, e.g., 3 minutes = 180s
let timerInterval = null;
const newPassword = ref('');
const confirmPassword = ref('');
const loadingChangePassword = ref(false);


// the change password section
function openChangePasswordModal() {
  reemail.value = agentStore.agentDetails?.user?.email || '';
  //  Profile Modal
  const profileModalEl = document.getElementById('profileNewModal');
  const profileModal = bootstrap.Modal.getInstance(profileModalEl);
  if (profileModal) {
    profileModal.hide();
  }
  //  email modal
  const emailAgentModalEl = document.getElementById('emailNewAgentModal');
  const emailAgentModal = new bootstrap.Modal(emailAgentModalEl);
  emailAgentModal.show();
}

async function validationMain() {
  // Reset errors
  errors.value.reemail = '';

  // Simple validation
  if (!reemail.value) {
    errors.value.reemail = 'Email is required';
    return;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(reemail.value)) {
    errors.value.reemail = 'Invalid email address';
    return;
  }

  try {
    loading.value = true;

    // Call API to resend OTP
    const sendOTP = await AgentOTPResend(reemail.value);

    if (sendOTP?.data?.success) {
      // Store email for OTP modal
      registeredEmail.value = reemail.value;

      // Show success toast
      toast.value?.showToast('OTP sent successfully!', 'success', 1000);

      // Close email modal
      const emailAgentModalEl = document.getElementById('emailNewAgentModal');
      const emailAgentModal = bootstrap.Modal.getInstance(emailAgentModalEl);
      if (emailAgentModal) emailAgentModal.hide();

      // Open OTP modal
      const otpModalEl = document.getElementById('otpNewModal');
      const otpModal = new bootstrap.Modal(otpModalEl);
      otpModal.show();

      // Reset OTP inputs
      otp.value = Array(otp.value.length).fill('');

      startTimer();
    } else {
      errors.value.reemail = sendOTP?.data?.message || 'Failed to send OTP';
    }

  } catch (err) {
    console.error(err);
    errors.value.reemail = 'Something went wrong. Please try again.';
  } finally {
    loading.value = false;
  }
}

function focusNext(index, event) {
  const inputs = document.querySelectorAll('.otp-box');
  if (event.inputType === 'deleteContentBackward') return;
  if (index < inputs.length - 1 && event.target.value) {
    inputs[index + 1].focus();
  }
}

function focusPrev(index, event) {
  const inputs = document.querySelectorAll('.otp-box');
  if (event.key === 'Backspace' && index > 0 && !event.target.value) {
    inputs[index - 1].focus();
  }
}

function startTimer() {
  if (timerInterval) clearInterval(timerInterval);
  timer.value = 180; // 3 minutes

  timerInterval = setInterval(() => {
    if (timer.value > 0) {
      timer.value -= 1;
    } else {
      clearInterval(timerInterval);
    }
  }, 1000);
}

async function handleResend(email) {
  if (timer.value > 0 || resendloading.value) return; // prevent multiple clicks

  resendloading.value = true;
  otp.value = Array(otp.value.length).fill(''); // reset OTP inputs

  try {
    const response = await AgentOTPResend(email);

    if (response?.data?.success) {
      toast.value?.showToast('OTP resent successfully!', 'success', 1000);
      startTimer(); // restart countdown
    } else {
      toast.value?.showToast(response?.data?.message || 'Failed to resend OTP', 'error');
    }
  } catch (err) {
    console.error(err);
    toast.value?.showToast('Something went wrong. Please try again.', 'error');
  } finally {
    resendloading.value = false;
  }
}

async function validationOTPMain(responseEmail) {
  // Reset error
  errors.value.otpError = '';

  // Combine OTP array into string
  const enteredOtp = otp.value.join('');

  if (!enteredOtp || enteredOtp.length !== otp.value.length) {
    errors.value.otpError = 'Please enter the complete OTP.';
    return;
  }

  try {
    loading.value = true;

    // Call API
    const res = await AgentVerifyOTP(responseEmail, enteredOtp);

    //console.log('OTP Verified:', res);

    if (!res.data.success) {
      errors.value.otpError = res.data.message || 'Invalid or expired OTP.';
      return;
    }

    // OTP verified successfully
    //toast.value?.showToast('OTP verified successfully!', 'success', 1000);

    // Close OTP modal
    const otpModalEl = document.getElementById('otpNewModal');
    const otpModal = bootstrap.Modal.getInstance(otpModalEl);
    if (otpModal) otpModal.hide();

    // Open Change Password Modal
    const changePasswordModalEl = document.getElementById('changeNewPasswordModal');
    const changePasswordModal = new bootstrap.Modal(changePasswordModalEl);
    changePasswordModal.show();

    // Optional: proceed to reset password modal
    // openResetPasswordModal();

  } catch (err) {
    console.error(err);
    errors.value.otpError = 'Something went wrong. Please try again.';
  } finally {
    loading.value = false;
  }
}

// Update password function
async function updatePassword(registeredEmail) {
  errors.value.passwordError = '';

  if (!newPassword.value || !confirmPassword.value) {
    errors.value.passwordError = 'Please fill both fields.';
    return;
  }

  if (newPassword.value !== confirmPassword.value) {
    errors.value.passwordError = 'Passwords do not match.';
    return;
  }

  try {
    loadingChangePassword.value = true;

    const res = await AgentUpdatePassword(registeredEmail, newPassword.value, confirmPassword.value);

    if (!res.data.success) {
      errors.value.passwordError = res.data.message || 'Failed to update password.';
      return;
    }

    toast.value?.showToast('Password updated successfully!', 'success', 1000);

    // Close Change Password Modal
    const changePasswordModalEl = document.getElementById('changeNewPasswordModal');
    const changePasswordModal = bootstrap.Modal.getInstance(changePasswordModalEl);
    if (changePasswordModal) changePasswordModal.hide();

    //After success, logout automatically
    try {
      const logoutRes = await AgentLogout();
    } catch (error) {
      console.error(error);
    } finally {
      
      agentStore.clearAgentDetails();
      setTimeout(() => {
        window.location.reload();
      }, 1500); 
    }


    // Optional: redirect to login page
    // router.push('/login');

  } catch (err) {
    console.error(err);
    errors.value.passwordError = 'Something went wrong. Please try again.';
  } finally {
    loadingChangePassword.value = false;
  }
}







// Dropdown methods
function toggleDropdown() {
  dropdownOpen.value = !dropdownOpen.value;
}

function goToProfile() {
  dropdownOpen.value = false;
  // Open Bootstrap modal instead of navigating
  const modalEl = document.getElementById('profileNewModal');
  const modal = new bootstrap.Modal(modalEl);
  modal.show();
}

async function logout() {
  dropdownOpen.value = false;

  try {
    const res = await AgentLogout();

    if (res.data && res.data.success) {
      toast.value?.showToast('Logout successful!', 'success', 1000); // 1 second
    } else {
      toast.value?.showToast(res.data.message || 'Logout failed!', 'error', 1000); // 1 second
    }
  } catch (error) {
    if (error.response) {
      toast.value?.showToast(error.response.data.message || `Error: ${error.response.status}`, 'error', 1000); // 1 second
    } else {
      toast.value?.showToast('Network or server error!', 'error', 1000); // 1 second
    }
  } finally {
    agentStore.clearAgentDetails();

    // Delay redirect slightly so toast is visible
    setTimeout(() => {
      router.push('/');
    }, 1200); // slightly longer than toast duration
  }
}

function toggleMobileMenu() {
  mobileMenuOpen.value = !mobileMenuOpen.value;
}


// Close dropdown on outside click
function handleClickOutside(event) {
  if (userBadge.value && !userBadge.value.contains(event.target)) {
    dropdownOpen.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>

<style scoped>

/* Arrow animation */
.arrow-down {
  transform: rotate(0deg);
  transition: transform 0.3s;
}
.arrow-up {
  transform: rotate(180deg);
  transition: transform 0.3s;
}

.user-dropdown {
  position: absolute;
  top: 40px;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  overflow: hidden;
  min-width: 140px;
  display: flex;
  flex-direction: column;
  z-index: 1000;
}

.user-dropdown .dropdown-item {
  padding: 8px 12px;
  background: none;
  border: none;
  text-align: left;
  font-weight: 500;
  color: #333;
}

.user-dropdown .dropdown-item.logout {
  color: #b71c1c;
  font-weight: 600;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>